<template>
  <Main />
  <Price />
  <Portfolio />
  <About />
  <Form />
</template>

<script>
import { WOW } from "wowjs";
import "animate.css";
import "bootstrap/dist/js/bootstrap.bundle.min.js";
import Main from "@/components/Main.vue";
import Price from "@/components/Price.vue";
import Portfolio from "@/components/Portfolio.vue";
import About from "@/components/About.vue";
import Form from "@/components/Form.vue";

export default {
  name: "HomeView",
  components: {
    Main,
    Price,
    Portfolio,
    About,
    Form,
  },
  mounted() {
    new WOW().init();
  },
};
</script>
